import { types as constantTypes } from 'app/constants/notificationType'

export const parseNotificationTypesBeforeSend = (type = 'email') => {
  if (type === constantTypes.BOTH) {
    return {
      sms: true,
      email: true,
    }
  } else {
    return {
      sms: type === constantTypes.SMS,
      email: type === constantTypes.EMAIL,
    }
  }
}

export const parseNotificationTypesBeforeShow = types => {
  if (types.sms && types.email) {
    return constantTypes.BOTH
  } else if (types.sms && !types.email) {
    return constantTypes.SMS
  } else {
    return constantTypes.EMAIL
  }
}
